import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { Chart, registerables } from 'chart.js';
import { Chart as ReactChart } from 'react-chartjs-2';
import { Box, } from '@mui/material';
import { customChartColors } from './chartColors';
Chart.register(...registerables, customChartColors);
Chart.defaults.set({
    font: {
        family: 'Gilroy, verdana, sans-serif',
    },
    borderWidth: 2,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        customChartColors: {
            enabled: true,
        },
        legend: {
            position: 'bottom',
            labels: {
                color: '#2a3846',
                padding: 8,
                usePointStyle: true,
            }
        },
        title: {
            color: '#2a3846',
            font: {
                size: 16,
                padding: 8,
                weight: '600'
            }
        },
        tooltip: {
            backgroundColor: '#2a3846',
            bodyColor: '#ffffff',
        }
    },
});
const DynamicChart = ({ config }) => {
    const chartRef = useRef(null);
    return (_jsx(Box, { sx: { padding: '10px', border: '1px solid #aaa', borderRadius: '4px', backgroundColor: 'white', }, children: _jsx(ReactChart, { ref: chartRef, type: config.type, data: config.data, options: config.options, style: { minWidth: '296px', minHeight: '300px' } }) }));
};
export default DynamicChart;
